import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const SubcategoryListReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);

  const fetchData = () => {
    Http.get("/sub-category-list").then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Sub Category List</h5>
          </div>

          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                    <thead>
                      <tr>
                        <th
                          className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                          style={{ width: "5%" }}
                        >
                          S/N
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Name
                        </th>
                        <th
                          className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                          style={{ width: "15%" }}
                        >
                          Code
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {receiveData &&
                        receiveData.map((item, index) => (
                          <>
                            <tr key={item.id}>
                              <td className="text-xs">{index + 1}</td>
                              <td className="text-xs" colSpan={2}>
                                <b>
                                  {item.code} - {item.name}
                                </b>
                              </td>
                            </tr>
                            {item.sub_category.map((item2, index2) => (
                              <tr key={item2.id}>
                                <td className="text-xs"></td>
                                <td className="text-xs">
                                  <Link
                                    to={{
                                      pathname:
                                        "/subcategory-ledger-report/" +
                                        item2.id,
                                    }}
                                  >
                                    {item2.name == "new" ? (
                                      <b>{item2.new_name}</b>
                                    ) : (
                                      <b>{item2.name}</b>
                                    )}
                                  </Link>
                                </td>
                                <td className="text-xs">{item2.code}</td>
                              </tr>
                            ))}
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubcategoryListReport;
